import * as React from 'react';
import { compose } from 'redux';

import type { WorkSummaryStatus } from '@acceligentllc/shared/enums/workSummaryStatus';
import { WorkSummaryStatusLabel } from '@acceligentllc/shared/enums/workSummaryStatus';

import AdditionalFilter from 'af-components/Table/Filters/AdditionalFilter/Multiselect';
import WSStatusLabel from 'af-components/WorkSummaryStatusLabel';

export interface WorkSummaryStatusFilterOption {
	id: string;
	label: string;
}

interface OwnProps {
	onChange: (options: WorkSummaryStatusFilterOption[]) => void;
	selected: WorkSummaryStatusFilterOption[];
	forBulkModal?: boolean;
	onClear?: () => void;
	autoOpen?: boolean;
}

type Props = OwnProps;

const options = Object.keys(WorkSummaryStatusLabel).map((key) => ({ id: key, label: WorkSummaryStatusLabel[key] }));

const WorkSummaryStatusFilter: React.FC<Props> = (props) => {

	const {
		onChange,
		selected,
		forBulkModal,
		onClear,
		autoOpen,
	} = props;

	const renderOption = React.useCallback((option: WorkSummaryStatusFilterOption) => {
		return (<WSStatusLabel status={option.id as WorkSummaryStatus} />);
	}, []);

	const onValueChange = React.useCallback((_options: WorkSummaryStatusFilterOption[]) => {
		onChange(_options);
	}, [onChange]);

	return (
		<AdditionalFilter
			autoOpen={!!autoOpen}
			filterName="Work Summary Status"
			forBulkModal={!!forBulkModal}
			onChange={onValueChange}
			onRemoveFilter={onClear}
			options={options}
			renderOptionOverride={renderOption}
			selected={selected}
		/>
	);
};

const enhance = compose<React.ComponentType<OwnProps>>(
	React.memo
);

export default enhance(WorkSummaryStatusFilter);
